// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"90c80c2e","77":"659f2968","115":"ba25f6ef","133":"6723cd55","222":"22024047","247":"965408c0","280":"5b7d06e9","320":"e0992ac7","354":"41b73d43","444":"31bd161e","526":"05bf3205","567":"588c856f","716":"03699caa","779":"1dd37c52","836":"545e7754","860":"ab37751a"}[chunkId] + ".chunk.js";
};